export const assessorIds = {
  transition: '19',
  beddedPack: '7',
  timeBudget: '4',
  freestall: '2',
};
